import React from 'react';
import PropTypes from 'prop-types';

const QuoteSetupModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const styles = {
    overlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    },
    modal: {
      backgroundColor: '#fff',
      borderRadius: '8px',
      padding: '24px',
      maxWidth: '500px',
      maxHeight: '80vh',
      width: '90%',
      overflowY: 'auto',
      position: 'relative',
      boxShadow: '0 10px 25px rgba(0, 0, 0, 0.2)'
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '20px',
      paddingBottom: '12px',
      borderBottom: '1px solid #e7e6e6'
    },
    title: {
      fontSize: '18px',
      fontWeight: '600',
      color: '#333',
      margin: 0
    },
    closeButton: {
      background: 'none',
      border: 'none',
      fontSize: '24px',
      cursor: 'pointer',
      color: '#6c757d',
      padding: '4px',
      borderRadius: '4px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '32px',
      height: '32px',
      transition: 'all 0.2s ease'
    },
    content: {
      color: '#333',
      lineHeight: '1.6'
    },
    section: {
      marginBottom: '20px'
    },
    sectionTitle: {
      fontSize: '14px',
      fontWeight: '600',
      color: '#333',
      marginBottom: '8px'
    },
    sectionContent: {
      fontSize: '14px',
      color: '#6c757d',
      lineHeight: '1.5'
    },
    fieldGroup: {
      display: 'flex',
      flexDirection: 'column',
      gap: '12px'
    },
    field: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '8px 0',
      borderBottom: '1px solid #f0f0f0'
    },
    fieldLabel: {
      fontSize: '14px',
      color: '#333',
      fontWeight: '500'
    },
    fieldValue: {
      fontSize: '14px',
      color: '#6c757d'
    },
    badge: {
      display: 'inline-block',
      padding: '4px 8px',
      backgroundColor: '#e3f2fd',
      color: '#1976d2',
      borderRadius: '12px',
      fontSize: '12px',
      fontWeight: '500'
    }
  };

  const handleOverlayClick = e => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div onClick={handleOverlayClick} style={styles.overlay}>
      <div style={styles.modal}>
        <div style={styles.header}>
          <h2 style={styles.title}>Quote Setup Details</h2>
          <button
            onClick={onClose}
            onMouseEnter={e => {
              e.target.style.backgroundColor = '#f8f9fa';
              e.target.style.color = '#333';
            }}
            onMouseLeave={e => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.color = '#6c757d';
            }}
            style={styles.closeButton}
          >
            ×
          </button>
        </div>

        <div style={styles.content}>
          <div style={styles.section}>
            <div style={styles.sectionTitle}>Current Quote Configuration</div>
            <div style={styles.fieldGroup}>
              <div style={styles.field}>
                <span style={styles.fieldLabel}>Quote Type</span>
                <span style={styles.fieldValue}>New Life Insurance</span>
              </div>
              <div style={styles.field}>
                <span style={styles.fieldLabel}>Coverage Amount</span>
                <span style={styles.fieldValue}>$500,000</span>
              </div>
              <div style={styles.field}>
                <span style={styles.fieldLabel}>Premium Type</span>
                <span style={styles.fieldValue}>Monthly</span>
              </div>
              <div style={styles.field}>
                <span style={styles.fieldLabel}>Gender</span>
                <span style={styles.fieldValue}>Male</span>
              </div>
              <div style={styles.field}>
                <span style={styles.fieldLabel}>Age</span>
                <span style={styles.fieldValue}>35 years</span>
              </div>
              <div style={styles.field}>
                <span style={styles.fieldLabel}>Health Class</span>
                <span style={styles.fieldValue}>Preferred Plus</span>
              </div>
              <div style={styles.field}>
                <span style={styles.fieldLabel}>Smoking Status</span>
                <span style={styles.fieldValue}>Non-Smoker</span>
              </div>
            </div>
          </div>

          <div style={styles.section}>
            <div style={styles.sectionTitle}>Selected Options</div>
            <div style={styles.fieldGroup}>
              <div style={styles.field}>
                <span style={styles.fieldLabel}>Jurisdiction</span>
                <span style={styles.badge}>California</span>
              </div>
              <div style={styles.field}>
                <span style={styles.fieldLabel}>Product Features</span>
                <span style={styles.fieldValue}>Term Life, Whole Life</span>
              </div>
              <div style={styles.field}>
                <span style={styles.fieldLabel}>Carriers Selected</span>
                <span style={styles.fieldValue}>5 carriers</span>
              </div>
            </div>
          </div>

          <div style={styles.section}>
            <div style={styles.sectionTitle}>Quote Status</div>
            <div style={styles.sectionContent}>Ready to generate quotes with current settings. Click "Get Quotes" to proceed with the configured parameters.</div>
          </div>
        </div>
      </div>
    </div>
  );
};

QuoteSetupModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

export default QuoteSetupModal;
